import { Board } from "../../../common/src/domain"
import { ZoomAndScrollControls } from "./board-scroll-and-zoom"
import { BoardFocus, getSelectedItems } from "./board-focus"
import { controlKey, installKeyboardShortcut } from "./keyboard-shortcuts"
import * as L from "lonna"

export function installZoomKeyboardShortcuts(
    { resetZoom, increaseZoom, decreaseZoom, zoomToFit }: ZoomAndScrollControls,
    board: L.Property<Board>,
    focus: L.Property<BoardFocus>,
) {
    installKeyboardShortcut(controlKey("+"), () => increaseZoom("preserveCursor"))
    installKeyboardShortcut(controlKey("-"), () => decreaseZoom("preserveCursor"))
    installKeyboardShortcut(controlKey("0"), () => resetZoom("preserveCursor"))
    // Shift-1: zoom to fit all, Shift-2: zoom to selection (as in Figma)
    const shiftDigit = (code: string) => (e: JSX.KeyboardEvent) =>
        e.shiftKey && !e.metaKey && !e.ctrlKey && !e.altKey && (e as any).code === code
    installKeyboardShortcut(shiftDigit("Digit1"), () => zoomToFit())
    installKeyboardShortcut(shiftDigit("Digit2"), () => {
        const selected = getSelectedItems(board.get())(focus.get())
        if (selected.length) zoomToFit(selected)
    })
}
